import { CSSProperties } from "react";

interface IColoredTextCellProps {
  text: string;
  color: string;
  onClick?: () => void;
  style?: CSSProperties;
}

export const ColoredTextCell = ({
  color,
  onClick,
  text,
  style,
}: IColoredTextCellProps) => {
  return (
    <div
      onClick={onClick}
      style={{ ...style, color: color, fontFamily: "unset" }}
      className={onClick ? "pointer" : undefined}
    >
      {text}
    </div>
  );
};
